<template>
  <div>
    <VTableRemote
      ref="tableRemoteRef"
      :iconHeader="'add'"
      :items="allPricingPeriods"
      hideDefaultFooter
      :headers="tableHeaders"
      :pagination="{}"
      isCustomIcon
      :isSearchable="false"
      :title="$t('administration.pricingManagement')"
      :endColumns="['actions']"
      :notSortableColumns="['actions']"
      :sortableColumns="['pricingPeriods']"
      :loading="isFetching"
      :isInfinitScroll="true"
      @iconAction="onClickAction"
    >
      <template #SearchWithFilters>
        <SearchWithFilters
          :filters="filters"
          :searchPlaceholder="$t('aquassistBilling.pricingManagement.labels.searchBy')"
          :filterName="filterName"
        />
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-start">
            <div
              class="d-flex align-center mLeft"
              @click="showData(item.id)"
            >
              <v-icon
                v-if="show[item.id]"
                large
                color="primary"
              >
                mdi-menu-down
              </v-icon>
              <v-icon
                v-else
                large
                color="primary"
              >
                mdi-menu-right
              </v-icon>
            </div>
          </td>
          <td class="text-start">
            <div class="pricingPeriod">
              <div>
                {{ $t('billing.filter.from') }}
                <span>{{ dateFormat(item.startDate) }}</span>
                <template v-if="item.endDate">
                  {{ $t('billing.filter.to') }}
                  <span>{{ dateFormat(item.endDate) }}</span>
                </template>
                <template v-else>
                  <span class="active-price-list"> {{ $t('billing.filter.to') }} -</span>
                </template>
              </div>
              <div
                v-if="item.color"
                class="pricingPeriodPoint"
              />
              <div
                v-if="item.active"
                class="pricingPeriodCurrent"
              >
                {{ $t('aquassistBilling.pricingManagement.labels.currentPeriod') }}
              </div>
            </div>
          </td>
          <td>
            <v-menu offsetY>
              <template #activator="{ on }">
                <div class="d-flex justify-end actionPadding">
                  <v-btn
                    color="primary"
                    xSmall
                    fab
                    rounded
                    v-on="on"
                  >
                    <v-icon>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </div>
              </template>

              <v-list>
                <!-- Edit -->
                <ListItem
                  icon="mdi-pencil"
                  :title="$t('forms.labels.edit')"
                  @click="updatePricingData(item)"
                />
                <!-- Active / Deactive -->
                <ListItem
                  :icon="item.active ? 'mdi-close-circle' : 'mdi-check-circle'"
                  :title="$t(`forms.btn.${getToogleStatus(item.active)}`)"
                  @click="ontoggleStatus(item.id, item.active)"
                />
              </v-list>
            </v-menu>
          </td>
        </tr>
        <td
          v-if="show[item.id]"
          class="AquassistManagePadding"
          :colspan="tableHeaders.length"
        >
          <AquassistManage
            :items="item"
          />
        </td>
      </template>
    </VTableRemote>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VTableRemote from '@/components/shared/content-views/VTableRemote';
import SearchWithFilters from '@/components/shared/SearchWithFilters.vue';
import ListItem from '@/components/shared/widgets/ListItem.vue';
import AquassistManage from '@/views/admin/aquassistBilling/pricingManagementDetails/AquassistManage.vue';
import Vue from 'vue';
import PricingPeriodForm from '@/components/forms/PricingPeriodForm.vue';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';
import moment from 'moment/moment';
import PricingUpdateInfo from '@/views/admin/aquassistBilling/pricingManagementDetails/PricingUpdateInfo.vue';

export default {
    name: 'PricingManagement',
    components: {
        AquassistManage,
        ListItem,
        SearchWithFilters,
        VTableRemote,
    },
    data() {
        return {
            isFetching: false,
            show: {},
            allPricingPeriods: [],
            existingDateRange: [],
            filterName: 'PricingManagement',
            filters: [
                {
                    key: 'date',
                    label: 'aquassistBilling.pricingManagement.labels.searchDatePeriod',
                    type: 'date',
                    value: [],
                    dateKeys: ['startDate', 'endDate'],
                    isRange: true,
                    datacy: 'billingFilterDate',
                },
            ],
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'userLang',
        ]),
        tableHeaders() {
            return [
                {
                    text: '',
                    value: 'icon',
                    sortable: false,
                    width: 20,
                },
                {
                    text: this.$t('aquassistBilling.pricingManagement.labels.pricingPeriods'),
                    value: 'pricingPeriods',
                },
                {
                    text: this.$t('table.actions'),
                    value: 'actions',
                    class: 'actionSpacing',
                },
            ];
        },
    },
    async created() {
        await this.getPricing();
    },
    methods: {
        ...mapActions({
            resetPricingPeriodUpdatedData: 'resetPricingPeriodUpdatedData',
        }),
        onClickAction(item) {
            if (item === 'add') {
                this.onClickAdd();
            }
        },
        getToogleStatus(active) {
            return !active ? 'activate' : 'deactivate';
        },
        onClickAdd() {
            this.$root.$emit('showModal', {
                title: this.$t('aquassistBilling.pricingManagement.labels.add'),
                component: Vue.component('PricingPeriodForm', PricingPeriodForm),
                onConfirm: async requestPayload => {
                    await this.addPricingPeriod(requestPayload);
                },
                controlledValidation: true,
                width: 650,
            });
        },
        updatePricingData(item) {
            this.$root.$emit('showModal', {
                title: this.$t('aquassistBilling.pricingManagement.labels.edit'),
                payload: { PricingPeriod: item },
                component: Vue.component('PricingUpdateInfo', PricingUpdateInfo),
                controlledValidation: true,
                resetData: this.resetPricingPeriodUpdatedData,
                onConfirm: async requestPayload => {
                    if (requestPayload) {
                        const { pricingPeriodId, params } = requestPayload.pricingPeriodUpdatedData;
                        await this.$rq.patchPricingConfig(pricingPeriodId, params);
                        this.$toasted.global.toast_success({
                            message: this.$t('msg.updatedPricingPeriod'),
                        });
                    }
                    await this.getPricing();
                },
                width: 930,
            });
        },
        async addPricingPeriod(requestPayload) {
            const formattedStartDate = this.dateFormat(requestPayload.startDate);
            let isInvalid = false;

            // Check if the start date is between any existing date ranges or matches an existing start date
            this.existingDateRange.forEach(([existingStart, existingEnd]) => {
                if (
                    moment(formattedStartDate).isBetween(existingStart, existingEnd, null, '[]')
                    || formattedStartDate === existingStart
                ) {
                    isInvalid = true;
                }
            });

            if (isInvalid) {
                this.$toasted.global.toast_error({
                    message: this.$t('msg.isOverlapMsg', { dateRange: formattedStartDate }),
                });
                return;
            }
            await this.$rq.addPricing(requestPayload);
            this.$toasted.global.toast_success({
                message: this.$t('msg.addedPricingPeriod'),
            });
            await this.getPricing();
        },
        async ontoggleStatus(pricingPeriod, status) {
            this.$root.$emit('showModal', {
                title: this.$t(`aquassistBilling.pricingManagement.labels.${this.getToogleStatus(status)}`),
                component: Vue.component('ConfirmForm', ConfirmForm),
                payload: { msg: this.$t(`aquassistBilling.pricingManagement.labels.${this.getToogleStatus(status)}Msg`) },
                onConfirm: async () => {
                    await this.$rq.patchPricingConfig(pricingPeriod, { active: !status });
                    this.$toasted.global.toast_success({
                        message: this.$t('msg.updatedPricingPeriod'),
                    });
                    await this.getPricing();
                },
                isForm: false,
            });
        },
        dateFormat(date) {
            return moment.utc(date).locale(this.userLang).format('L');
        },
        showData(item) {
            this.show = {
                ...this.show,
                [item]: !this.show[item],
            };
        },
        async getPricing() {
            this.isFetching = true;
            const { data } = await this.$rq.getPricings();
            this.existingDateRange = data.map(dateRange => [
                this.dateFormat(dateRange.startDate),
                dateRange.endDate ? this.dateFormat(dateRange.endDate) : null,
            ]);
            this.allPricingPeriods = data;
            this.isFetching = false;
        },
    },
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/pricingManagement.scss";
::v-deep .actionSpacing span {
    padding-right: 1.5rem;
}
</style>
